import { useEffect, useRef } from 'react';
import socket from 'shared/socket';
import { getSchemaName } from 'shared/api';

const MAX_RECEIVED_IDS = 500;

const useTrabajadorSocket = ({
  onNuevoMensaje,
  onPedidoActualizado,
  onChatTomado,
  onCartUpdate,
  onChatLiberado,
  onAsesorSolicitado,
}) => {
  const callbacksRef = useRef({
    onNuevoMensaje,
    onPedidoActualizado,
    onChatTomado,
    onCartUpdate,
    onChatLiberado,
    onAsesorSolicitado,
  });
  callbacksRef.current = {
    onNuevoMensaje,
    onPedidoActualizado,
    onChatTomado,
    onCartUpdate,
    onChatLiberado,
    onAsesorSolicitado,
  };

  const receivedIdsRef = useRef(new Set());

  useEffect(() => {
    const onConnect = () => {
      const user = JSON.parse(localStorage.getItem('usuario') || 'null');
      const idempresa = user?.idempresa;
      if (idempresa) {
        socket.emit('join_room', `e${idempresa}_asesores`);
      }
    };

    if (!socket.connected) socket.connect();
    else onConnect();

    const handleNuevoMensaje = (data) => {
      if (!callbacksRef.current.onNuevoMensaje) return;

      const currentSchema = getSchemaName();
      const msgSchema = data.schema || data.schema_name;
      if (msgSchema && currentSchema && msgSchema !== currentSchema) return;

      if (data.id) {
        const ids = receivedIdsRef.current;
        if (ids.has(data.id)) return;
        ids.add(data.id);
        if (ids.size > MAX_RECEIVED_IDS) {
          const arr = Array.from(ids);
          arr.slice(0, Math.floor(MAX_RECEIVED_IDS / 2)).forEach((id) => ids.delete(id));
        }
      }

      callbacksRef.current.onNuevoMensaje(data);
    };
    const handlePedidoActualizado = (data) => {
      if (callbacksRef.current.onPedidoActualizado) callbacksRef.current.onPedidoActualizado(data);
    };
    const handleChatTomado = (data) => {
      if (callbacksRef.current.onChatTomado) callbacksRef.current.onChatTomado(data);
    };
    const handleCartUpdate = (data) => {
      if (callbacksRef.current.onCartUpdate) callbacksRef.current.onCartUpdate(data);
    };
    const handleChatLiberado = (data) => {
      if (callbacksRef.current.onChatLiberado) callbacksRef.current.onChatLiberado(data);
    };
    const handleAsesorSolicitado = (data) => {
      if (callbacksRef.current.onAsesorSolicitado) callbacksRef.current.onAsesorSolicitado(data);
    };

    socket.on('connect', onConnect);
    socket.on('nuevo_mensaje', handleNuevoMensaje);
    socket.on('pedido_actualizado', handlePedidoActualizado);
    socket.on('chat_tomado', handleChatTomado);
    socket.on('cart_update', handleCartUpdate);
    socket.on('chat_liberado', handleChatLiberado);
    socket.on('asesor_solicitado', handleAsesorSolicitado);

    return () => {
      socket.off('connect', onConnect);
      socket.off('nuevo_mensaje', handleNuevoMensaje);
      socket.off('pedido_actualizado', handlePedidoActualizado);
      socket.off('chat_tomado', handleChatTomado);
      socket.off('cart_update', handleCartUpdate);
      socket.off('chat_liberado', handleChatLiberado);
      socket.off('asesor_solicitado', handleAsesorSolicitado);
    };
  }, []);
};

export default useTrabajadorSocket;
